import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    id: 0,
    name: "",
    lastName: "",
    email: "",
    userTypeId: 0,
    roleId: 0,
    entityId: null,
    token: null,
    expiresUtc: "",
};

const userSlice = createSlice({
    name: "userStore",
    initialState,
    reducers: {
        authUser(state, action) {
            state.id = action.payload.id;
            state.name = action.payload.name;
            state.lastName = action.payload.lastName;
            state.email = action.payload.email;
            state.userTypeId = action.payload.userTypeId;
            state.entityId = action.payload.entityId;
            state.roleId = action.payload.roleId;
        },
        logOutUser(state, action) {
            state.id = 0;
            state.name = "";
            state.lastName = "";
            state.email = "";
            state.roleId = 0;
            state.userTypeId = 0;
            state.entityId = null;
        },
        updateUser(state, action) {
            state.name = action.payload.name;
            state.lastName = action.payload.lastName;
            state.email = action.payload.email;
        },
    },
});

export const userSliceActions = userSlice.actions;
export default userSlice.reducer;
